/* eslint-disable no-undef */
import { JSON_HEADER, AUTH_HEADER } from '../../config';
import config from '../../config.json';
import configInstance from '../../configSingleton';
import { REDUX_CONSTANT } from '../../constants/index';
import * as TYPES from '../types';
import { createEndpoint } from './../../helpers/commonHelper';

const util = require('util');

export const onLoad = () => ({
    type: TYPES.ON_LOAD,
    payload: {
        isLoading: false
    }
});

export const onfail = (msg, title = '') => ({
    type: TYPES.ERROR,
    payload: { msg, title }
});

export const storeAccountInformation = (account) => {
    return {
        payload: { account },
        type: REDUX_CONSTANT.AUTH.LOGIN_SUCCESS
    };
};

export const getConfigHashValue = () => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(config.REACT_APP_GET_HASH_VALUE_URL)}`,
            method: 'GET',
            extraHeaderObject: {
                Origin: location.origin
            },
            onsuccess: handleConfigHashValueSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_HASH_VALUE,
            showLoader: false
        }
    };
};

const handleConfigHashValueSuccess = (payload) => {
    return (dispatch) => {
        const newHash = payload;
        const storedHash = localStorage.getItem('configHashValue');

        if (
            String(newHash) !== String(storedHash) ||
            !configInstance.isSingletonUpdated
        ) {
            // Save the new hash
            localStorage.setItem('configHashValue', newHash);

            // Call getConfigurationValue since hash changed
            dispatch(getConfigurationValue());
        } else {
            // Hash is the same, no need to call getConfigurationValue
            dispatch(getConfigurationValueSuccess());
        }

        dispatch({
            payload,
            type: REDUX_CONSTANT.GET_HASH_VALUE
        });
    };
};

export const getConfigurationValue = () => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(config.REACT_APP_GET_CONFIGURATION_VALUE_URL)}`,
            method: 'GET',
            extraHeaderObject: {
                Origin: location.origin
            },
            onsuccess: getConfigurationValueSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_CONFIGURATION_VALUE,
            showLoader: false
        }
    };
};

export const getConfigurationValueSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_CONFIGURATION_VALUE
    };
};

export const updateVendorId = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.AUTH.UPDATE_ACQUIRED_VENDOR_ROLE
    };
};

export const getVendorInformation = (vendorId) => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.vendorService
        )}${util.format(config.REACT_APP_GET_VENDOR_URL, vendorId)}`,
        method: 'GET',
        onsuccess: getVendorInformationSuccess,
        onerror: onfail,
        title: REDUX_CONSTANT.GET_VENDOR_INFORMATION
    }
});

export const isVendorInfoUpdated = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.UPDATE_VENDOR_INFO_DATA
    };
};

export const getVendorInformationSuccess = (payload) => {
    return (dispatch) => {
        dispatch({
            payload,
            type: REDUX_CONSTANT.GET_VENDOR_INFORMATION
        });
    };
};

export const resetVendorInformationState = (value) => {
    return (dispatch) => {
        dispatch({
            payload: value,
            type: REDUX_CONSTANT.GET_VENDOR_INFORMATION
        });
    };
};

export const getRolesPermissionInformation = (email) => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.configurationService
        )}${util.format(config.REACT_APP_GET_PERMISSION_ROLES_URL, email)}`,
        method: 'GET',
        onsuccess: getRolesPermissionSuccess,
        onerror: onfail,
        title: REDUX_CONSTANT.ROLES_PERMISSION_INFORMATION
    }
});

export const getRolesPermissionSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.ROLES_PERMISSION_INFORMATION
    };
};

export const setRolesPermissionInformation = (vendorInfo) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${config.REACT_APP_SET_PERMISSION_ROLES_URL}`,
            method: 'POST',
            body: JSON.stringify(vendorInfo),
            onsuccess: setRolesPermissionSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.ROLES_PERMISSION_INFORMATION
        }
    };
};

export const setRolesPermissionSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.ROLES_PERMISSION_INFORMATION
    };
};

export const updateRolesPermissionInformation = (vendorInfo, email) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(config.REACT_APP_GET_PERMISSION_ROLES_URL, email)}`,
            method: 'PATCH',
            body: JSON.stringify(vendorInfo),
            onsuccess: setRolesPermissionSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.ROLES_PERMISSION_INFORMATION
        }
    };
};

export const updateRolesData = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.UPDATE_ROLES_DATA
    };
};

/**
 * Function call setting login dt API
 *
 * @param - token - type (string)
 * @param - email - type (string) should in caps
 *
 */
export const setPlatformUserLogin = (email) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(config.REACT_APP_PLATFORM_USER_LOGIN_URL, email)}`,
            method: 'POST',
            onsuccess: setPlatformUserLoginSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.PLATFORM_USER_LOGIN
        }
    };
};

/**
 * Function handle onsuccess scenario of setPlatformUserLogin
 *
 */
export const setPlatformUserLoginSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.PLATFORM_USER_LOGIN
    };
};

export const resetOnLogout = () => {
    return {
        type: REDUX_CONSTANT.LOGOUT_RESET
    };
};

export const resetVendorData = () => {
    return {
        type: REDUX_CONSTANT.RESET_VENDOR_DATA
    };
};
